import { createContext, useContext } from 'react';
import { IRioSelectContext } from './types';

const RioSelectContext = createContext<
  IRioSelectContext & { isSearchMenuEnabled: boolean; isCustomMenuTriggers: boolean; selected: any }
>({} as IRioSelectContext & { isSearchMenuEnabled: boolean; isCustomMenuTriggers: boolean; selected: any });

export const RioSelectProvider = RioSelectContext.Provider;

export const useRioSelectContext = () => {
  return useContext(RioSelectContext);
};
